import { AsyncSelect, AsyncSelectProps } from "@sembark-travel/ui-base"
import { useXHR } from "@sembark-travel/xhr"
import { activityPaymentPreferencesXHR as XHR } from "./store"

export function SelectActivityPaymentReferences({
	...otherProps
}: Readonly<Omit<AsyncSelectProps, "fetch">>) {
	const xhr = useXHR()
	return (
		<AsyncSelect
			multiple
			{...otherProps}
			fetch={(q) =>
				XHR(xhr)
					.getActivityPaymentReferences({ q })
					.then((resp) => resp.data)
			}
		/>
	)
}
